module.exports = __webpack_public_path__ + "static/media/logo.260b28ff.svg";